var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      class: {
        "qp-info-icon": true,
        "qp--ada-disabled": _vm.disableAdaCompliance,
      },
      attrs: {
        tabindex: "0",
        title: "Zip - Buy now pay later.",
        role: "button",
        "aria-label":
          "Info icon, when clicked, opens infographic about the option of buying this item with 4 installment payments",
      },
    },
    [_vm._v("\n  ⓘ\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }